import React, { useState, useEffect } from 'react';
import { Layout, Avatar, Menu, Card, Dropdown, Row, Col, Typography, Button, Popover, Result, Tooltip } from 'antd';
import {
	UserOutlined,
	LogoutOutlined,
	CloseCircleOutlined,
} from '@ant-design/icons';


import './index.css';
import { useNavigate, useParams } from 'react-router-dom';
import { LanguageContext, POST, TranslateContext, useAuth, UserConfigContext, UserContext } from 'fennec-ui';
import { errorCatch, GET, QueryDetail, READWITH, ycStorage } from 'fennec-ui';



import { useDispatch, useSelector } from 'react-redux';
import REDUX_AkkauntiPolzovatelei from '../../../objects/AkkauntiPolzovatelei/reducer';
import { MetaContext } from 'fennec-ui';
import Icofont from 'react-icofont';
import REDUX_UserConfig from '../../../objects/UserConfig/reducer'
import REDUX_Translate from '../../../objects/Translate/reducer';
import { translate, ycBucket } from '../../../common/Tool';
import FedHeader from '../FedHeader'
import FedSubheader from '../FedSubheader'
import { LangSwitchContext, useIsDesktopOrLaptopContext, useIsMobileContext, useLayoutWidthContext } from '../../../common/Context';
import LangSwitch from '../../components/LangSwitch';

const { Paragraph, Text } = Typography;

var _ = require('lodash');

const { Header, Content, Footer, Sider } = Layout;


function PaymentResult(props) {
	let navigate = useNavigate();
	let { number } = useParams();
	const auth = useAuth();
	const dispatch = useDispatch();
	const userConfig = useSelector(REDUX_UserConfig.selector.object) || {};
	const translates = useSelector(REDUX_Translate.selector.object);
	const [language, setLanguage] = useState({ lang: (auth.getCookie("lang") || "ru") })
	const t = React.useMemo(() => _.bind(translate, {
		translate: translates,
		config: language
	}), [translates, language]);
	// const t = useTranslateContext();
	// console.log(t("да"));

	const setUserConfig = (name, value, onChange) => {
		POST(auth, "/api/setuserconfig", {
			key: name,
			value: value
		}, ({ data }) => {
			var arr = [data];
			var obj = Object.fromEntries(arr.map(i => {
				return [
					i.key,
					i.value
				]
			}));
			let i = { ...userConfig, ...obj };
			let o = REDUX_UserConfig.actions.setObject(i);
			dispatch(o);
			if (onChange) {
				onChange(i);
			}
		}, errorCatch);
	};

	//-------------------------------------------------------------
	const [layout, setLayout] = useState("web"); // app | web
	const [showContentMenu, setShowContentMenu] = useState(false);
	const [showRightSider, setShowRightSider] = useState(false);
	const [showLeftSider, setShowLeftSider] = useState(false);
	const [showHeader, setShowHeader] = useState(false);
	const [showSubheader, setShowSubheader] = useState(true);
	const [loading, setLoading] = useState(false);
	const [fullwidth, setFullwidth] = useState(false);
	//-------------------------------------------------------------
	const meta = useSelector(state => state.meta);

	const [collapsed, setCollapsed] = useState(true);
	const [user, setUser] = useState();
	const [zakaz, setZakaz] = useState(undefined);

	useEffect(() => {
		subscribe();
		return () => {
			unsubscribe();
		};
	}, []);
	const subscribe = () => {
		auth.fetch('/api/meta').then(res => {
			if (res && res.data && dispatch) {
				dispatch({ type: 'META', payload: res.data })
			}
		});
		auth.fetch('/api/iam').then(res => {
			if (res && res.data) {
				setUser(res.data);
			}
		});
		setLoading(true);
		GET(auth, `/api/zakaz/by-nomer-for-payment-result-page/${number}`,
			({ data }) => {
				if (data) {
					if (data?.status?.ID == 1) {
						let count = 10;
						let intervalId = setInterval(() => {
							count--;
							if (count == 0) {
								clearInterval(intervalId);
							}
							GET(auth, `/api/zakaz/by-nomer-for-payment-result-page/${number}`,
								({ data }) => {
									if (data) {
										if (data?.status?.ID != 1) {
											clearInterval(intervalId);
										}
										setZakaz(data);
									}
									setLoading(false);
								}, (err) => errorCatch(err, () => setLoading(false)));
						}, 5000)
					}
					setZakaz(data);
				}
				setLoading(false);
			}, (err) => errorCatch(err, () => setLoading(false)));
		RefreshAkkaunti();
		auth.openSocket("/ws/service", "service", function (type, payload) {
			if (type === "reload") {
				window.location.href = window.location.href;
			}
			switch (type) {
				case "siteaccess":
					dispatch({ type: "SITE_ACCESS", payload: payload });
					break;
				case "AkkauntiPolzovatelei":
					dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray([payload]));
					break;
				case "NeedUpdateAkkauntPolzovatelya":
					RefreshAkkaunti();
					break;
				default:
					break;
			}
		});
	};
	const unsubscribe = () => {
		auth.closeSocket("service");
	};

	const _RefreshAkkaunti = () => {
		READWITH(auth, "AkkauntiPolzovatelei", [
			QueryDetail("model")
		], ({ data }) => {
			if (data) {
				dispatch(REDUX_AkkauntiPolzovatelei.actions.updateArray(data));
			}
		}, errorCatch);
	};
	var RefreshAkkaunti = _.throttle(_RefreshAkkaunti, 3000, { 'trailing': false });

	const logout = () => {
		auth.logout(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const logoutall = () => {
		auth.logoutall(() => {
			navigate('/app');
			// history.go(0);
		});
	}
	const goToHome = () => {
		navigate("/app");
	}
	const goToOneMoreOrder = () => {
		if (zakaz) {
			navigate(`/app/pay/${zakaz.meropriyatieID}`);
		}
	}
	const [layoutWidth, setLayoutWidth] = useLayoutWidthContext();
	const isMobile = useIsMobileContext();
	const isDesktopOrLaptop = useIsDesktopOrLaptopContext();
	const style = () => {
		return {
			fullwidth: {
				layout: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, margin: "0 auto" },
				header: (fullwidth || !isDesktopOrLaptop) ? {} : { width: layoutWidth, padding: "0", margin: "0 auto" },
			},
			content: {
				minHeight: 600,
				paddingTob: "0px",
				paddingRight: (!showRightSider) ? "0px" : "10px",
				paddingBottom: "0px",
				paddingLeft: (!showLeftSider) ? "0px" : "10px",
				// background: "white"
			}
		}
	};
	const changeFullwidth = () => {
		setFullwidth(!fullwidth ? true : false);
	};

	return (
		<TranslateContext.Provider value={t}>
			<MetaContext.Provider value={meta}>
				<UserContext.Provider value={user}>
					<UserConfigContext.Provider value={[userConfig, setUserConfig]}>
						<LanguageContext.Provider value={[language, setLanguage]}>
							<LangSwitchContext.Provider value={<LangSwitch userConfig={userConfig} />}>
								<Layout>
									<FedHeader user={user} logout={logout} logoutall={logoutall} layout={layout} fullwidth={fullwidth} />
									{/* {showSubheader && <FedSubheader layout={layout} fullwidth={fullwidth} changeFullwidth={changeFullwidth} />} */}
									<Content style={{ padding: '6px' }}>
										<Layout style={style().fullwidth.layout}>
											{showLeftSider && <Sider theme="light"></Sider>}
											<Content style={{ ...style().content }}>
												<div style={{ display: "flex", justifyContent: "space-between" }}>
													<div style={{ flex: "auto" }}>
														<div style={{ backgroundColor: "white", borderRadius: "4px" }}>
															<div style={{ padding: "10px" }}>
																{(zakaz?.status?.ID === 1) && <Result
																	status={"info"}
																	title={"Ожидаем поступления денежных средств"}
																	subTitle={<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>}
																	extra={[
																		<Button type="primary" key="console" onClick={goToHome}>
																			Личный кабинет
																		</Button>,
																		<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>,
																	]}
																/>}
																{(zakaz?.status?.ID === 2) && <Result
																	status="warning"
																	title="Оплата возвращена!"
																	subTitle={<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>}
																	extra={[
																		<Button type="primary" key="console" onClick={goToHome}>
																			Личный кабинет
																		</Button>,
																		<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>,
																	]}
																/>}
																{(zakaz?.status?.ID === 3 || zakaz?.status?.ID === 4) && <Result
																	status={"success"}
																	title={"Заказ успешно оплачен!"}
																	subTitle={<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>}
																	extra={[
																		<Button type="primary" key="console" onClick={goToHome}>
																			Личный кабинет
																		</Button>,
																		<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>,
																	]}
																/>}
																{(zakaz?.status?.ID === 5) && <Result
																	status="error"
																	title="Ошибка оплаты заказа!"
																	subTitle={<div>
																		<div>Номер заказа: {number}</div>
																		<div>Сумма заказа: <span style={{ color: "black" }}>{zakaz.obshchayaSumma.toLocaleString()} руб.</span></div>
																	</div>}
																	extra={[
																		<Button type="primary" key="console" onClick={goToHome}>
																			Личный кабинет
																		</Button>,
																		<Button key="buy" onClick={goToOneMoreOrder}>Ещё один заказ</Button>,
																	]}
																>
																	<div className="desc">
																		<Paragraph>
																			<Text
																				strong
																				style={{
																					fontSize: 16,
																				}}
																			>
																				Во время оплаты банковской картой произошла ошибка:
																			</Text>
																		</Paragraph>
																		<Paragraph>
																			<CloseCircleOutlined className="site-result-demo-error-icon" /> Убедитесь что на счете карты достаточно средств и карта не заблокирована.
																		</Paragraph>
																	</div>
																</Result>}
															</div>
														</div>
													</div>
												</div>
											</Content>
											{showRightSider && <Sider width={185} theme={"light"}></Sider>}
										</Layout>
									</Content>
									<Footer style={{ textAlign: 'center' }}>
										Общероссийская физкультурно-спортивная общественная организация "Всероссийская федерация социальных танцев"
									</Footer>
								</Layout>
							</LangSwitchContext.Provider>
						</LanguageContext.Provider>
					</UserConfigContext.Provider>
				</UserContext.Provider>
			</MetaContext.Provider>
		</TranslateContext.Provider>
	);
};

export default React.memo(PaymentResult);
// Payment.whyDidYouRender = true